import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

interface SeoData {
  title: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class SeoManager {
  title = inject(Title);
  meta = inject(Meta);

  private readonly siteName = 'Drazamed';

  updateSeoTags(seoData: SeoData) {
    this.title.setTitle(`${seoData.title} | ${this.siteName}`);
    this.meta.updateTag({ name: 'og:title', content: `${seoData.title} | ${this.siteName}`});

    this.meta.updateTag({ name: 'description', content: seoData.description });
    this.meta.updateTag({ name: 'og:description', content: seoData.description });
  }

}
